module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Продукт":"Product","Номер лицензии":"Serial number","Код активации":"Activation code"}}')
  delete Component.options._Ctor
}
